import { ChipFilter } from '@/pages/AdvancedEditor/components/panels/common/ChipFilter';
import styled from '@emotion/styled';
import { SectionTitle } from '../../../AspectRatioDropdown';

const SidebarSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    .MuiTabs-root {
        min-height: unset;
    }

    .MuiTabs-flexContainer {
        gap: 8px;
        flex-wrap: wrap;
    }
`;

interface SidebarFilterProps {
    title: string;
    filter: string;
    options: Array<{ id: string; label: string; active: boolean }>;
    onChange: (value: string) => void;
}

export const SidebarFilter = ({ title, filter, options, onChange }: SidebarFilterProps) => (
    <SidebarSection>
        <SectionTitle>{title}</SectionTitle>
        <ChipFilter tabs={options} maxWidth="392px" activeTab={filter} onTabChange={onChange} />
    </SidebarSection>
);
